var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailUs(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.848 19.263H2.366a.782.782 0 01-.78-.78V2.365c0-.43.35-.78.78-.78h29.482c.43 0 .78.35.78.78V18.48c0 .43-.35.78-.78.78z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.585 2.232l15.522 11.54 15.52-11.54m-7.843 6.47l7.064 10.56M9.196 8.703l-7.064 10.56"
  }))));
}
export default SvgEmailUs;